
<header class="p-3 bg-white left-0">
    <img src="assets/images/logo-q-2.png" width="200px">

</header>
<div class="steps-padding">
    <div class="container">
        <div class="row">
            <div class="col-md-10 m-auto col-xl-9">
                <h1 class="text-center large mt-0 mb-3 text-white">Your health is <span
                        class="text-white"><strong>{{result.grade}}</strong></span>
                </h1>
                <span class="line-data"></span>
                <h3 class="text-center large mb-3 text-white">Watch this video and then schedule a call to see how we can help you
                    achieve
                    your full human potential.</h3>
            </div>
        </div> 
    </div>
</div>
<div class="container data-top">
    <div class="row">
        <div class="col-md-10 m-auto col-xl-9">
            <p class="text-center marging-neg">
                <iframe [src]="result.videoURL | safe: 'resourceUrl'" width="100%" height="360" frameborder="0"
                    allow="autoplay; fullscreen" allowfullscreen></iframe>
            </p>
        </div>
        <div class="col-md-10 m-auto col-xl-9" *ngIf="predata && userLocation">
                <div class="box-scdule mat-card mt-4 mb-5 p-5">
                <h3 class="text-center mb-4">If you have any questions about your assessment results to ask our experts, please fill in the
                    contact form below:</h3>

                    <form ngNoForm action="https://getform.io/f/1fc7c79c-4947-4bf0-9299-0cac849a022e" method="POST">
                       <div class="form-group">
                        <input type="hidden"  name="createdAt" value="{{predata?.createdAt}}">
                        
                        <textarea class="form-control" type="text" name="message"></textarea>
                        <input type="hidden" name="firstName" value="{{predata?.firstName}}">
                        <input type="hidden" name="lastName" value="{{predata?.lastName}}">
                        <input type="hidden"  name="email" value="{{predata?.email}}">
                        <input type="hidden" name="phone" value="{{predata?.phone}}">
                        <input type="hidden" name="goal" value="{{predata?.goal}}">
                        <input type="hidden" name="profile" value="{{predata?.profile}}">

                        <input type="hidden" name="city" value="{{userLocation?.city}}">
                        <input type="hidden" name="stateProv" value="{{userLocation?.stateProv}}">
                        <input type="hidden" name="countryName" value="{{userLocation?.countryName}}">
                        <input type="hidden" name="continentName" value="{{userLocation?.continentName}}">
                        <input type="hidden" name="ipAddress" value="{{userLocation?.ipAddress}}">
                       </div> 
                   
                        <button type="submit" class="btn btn-primary p-color">Submit</button>
                    </form>
              
            </div>
        </div>
        <!-- <div #widget class="col-md-10 m-auto col-xl-9">
            <h1 class="text-center">Schedule a call with an <span class="text-primary">Qineticare Consultant</span></h1>
            <div  *ngIf="widgetHtml" [innerHTML]="widgetHtml" appRunScripts></div>
        </div> -->
    </div> 
</div>
<div class="flex ft-q">

    <a href="/"><img src="assets/images/logo.png" width="150px"></a>
    <p class="my-2 pl-5 text-gray"><small>© Apeiron 2021. All Rights Reserved</small></p>
</div>